export const SectionHeading = ({ label, title }) => (
  <div className="mb-9 lg:mb-12">
    <p className="text-xs tracking-[0.3em] uppercase text-gold mb-2">{label}</p>
    <h2 className="font-serif text-3xl lg:text-4xl font-bold text-white">{title}</h2>
  </div>
);
